// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let tangent_recommended_products;
let default_addToCartText = "Ajouter au panier";
let default_addedToCartText = "Ajouté au panier !";
let default_add_all_to_cart_text = "Tout ajouter au panier";
let tangent_client_domain_currency;
let tangent_facemap_data;

const out_of_stock_text = "En rupture de stock";
const no_products_found_text = "Aucun produit trouvé. Veuillez réessayer!";
const tangent_skin_type_tagging = document.querySelector("#skin-type-taging");

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map = {};

// Tab title mapping based on tags
const tabs_title_mapping = {
    section_basics: "Essentiels ciblés",
    section_essentials: "Routine d'une journée complète",
    section_works: "Collection de soins Prestige"
}

// Sections that should NOT get the "tabcontent" class or Have a tab button
const excludedSections = [
    "section_selfie"
];

const excludeProductSections = ["cleanser",
    "exfoliator",
    "mask",
    "moisturizer",
    "serum",
    "specific",
    "toner"];

// Add default image url here
const tangent_default_selfie_image_url = "https://yonka.com/cdn/shop/articles/3-gestes-pour-prendre-soin-de-sa-peau-l-hiver_83847157-ede4-4cab-b8d2-9d8d55bd9410.jpg?v=1769076235";
const default_variant_image_url = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message");
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper");

// Message for each conditions
const condition_text_mapping = {
    dark_circles: "Prone to dark circles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>.",
    wrinkles: "Prone to wrinkles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    rosacea: "Prone to rosacea here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    texture: "Prone to texture here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    darkspots: "Prone to darkspots here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    acne: "Prone to Blemish here! Try our <a target='_blank' href='#'><u>Product Name</u></a>"
}

window.onload = function () {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId() {
    // Current Page Load URL
    var tangent_client_url = new URL(window.location.href);
    return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id) {
    if (tangent_response_id != null) {
        var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + tangent_response_id + "&self_serve=true" + "&multiple_variants=true";
        fetch(checkout_url)
            .then(data => {
                return data.json();
            })
            .then(response => {
                checkoutDataProcess(response);
                return response;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

function checkoutDataProcess(response) {
    tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText;

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // API call for facemapping
    if (response["selfie_id"] != null) {
        setSelfieId(response["selfie_id"]);
        getSelfieMapping(response["selfie_id"]);
        enableSelfieDependedStaticElements();
    }
    else {
        document.getElementById("skin-type-taging").style.cssText = "border-bottom: 0.2px solid #cccccca6; padding-bottom: 12px;";
        setTangentDefaultSelfie();
    }

    renderTags(response.tags);
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;

    if (tangent_product_sections != undefined) {
        createProductSection(tangent_product_sections, tangent_text_sections);
    }

    setTabOpen(response.tags);
    if (response.text_sections != undefined) {
        createTextSection(tangent_product_sections, tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        loadElementsOnResponseData();
        enableButtonListener();

        document.dispatchEvent(new CustomEvent('products-loaded'));

        centerActiveTabWhenMobile();

        let section_grid = document.getElementById("section_professional_treatment_text_container");
        if (section_grid) {
            createScrollButtons(section_grid);
        }
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        setElementDisplay("tangent-general-text", "block");
    }

}

function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};
    Object.keys(sections).forEach(section => {
        const product_ids = sections[section];
        // Get the product section grid element once per section
        let product_section_grid = document.getElementById(section + "_product_grid");

        // Create a variable to accumulate the HTML
        let section_html = "";
        for (let id of product_ids) {
            for (let p = 0; p < products.length; p++) {
                if (String(products[p].id) === id) {
                    let product = products[p];

                    let variant = getSelectedVariant(product, selected_variants);

                    // Update the selected product map
                    tangent_selected_product_map[product.id] = variant.id;

                    // Generate the product HTML
                    let product_html = getProductHTML(product, variant, section);

                    section_html += product_html;

                }
            }
        }

        if (product_ids.length > 2) {
            // createScrollButtons(product_section_grid);
        }

        // Append all the HTML to the section's product grid in one go
        product_section_grid.insertAdjacentHTML('beforeend', section_html);
    });
}

function createScrollButtons(sectionGrid) {
    // Remove existing buttons first if any
    const existingBtns = sectionGrid.parentElement.querySelector(".scroll-btn-container");
    if (existingBtns) existingBtns.remove();

    const scrollerContainer = document.getElementById("treatments-container");
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "scroll-btn-container";

    // Right button
    const rightBtn = document.createElement("button");
    rightBtn.className = "scroll-btn scroll-right";
    rightBtn.id = scrollerContainer.id + "_right_scroll";
    rightBtn.innerHTML = `<svg-icon src="icon-arrow" class="" style="--icon-size: 16px;"><template shadowrootmode="open"><!---->
      <svg class="block h-full w-full" aria-label="Icon for icon-arrow">
        <use crossorigin="anonymous" href="//is-clinical-production.myshopify.com/cdn/shop/t/47/assets/icons.svg?v=117055188062501076751758611687#icon-arrow"></use>
      </svg>
    </template></svg-icon>`;
    rightBtn.addEventListener("click", () => {
        leftBtn.disabled = false;
        scrollerContainer.scrollBy({ left: 332, behavior: "smooth" });
        setTimeout(() => {
            if (scrollerContainer.scrollLeft + scrollerContainer.clientWidth >= scrollerContainer.scrollWidth - 1) {
                rightBtn.disabled = true;
            }
        }, 100);

    });
    buttonContainer.appendChild(rightBtn);

    // Left button
    const leftBtn = document.createElement("button");
    leftBtn.className = "scroll-btn scroll-left";
    leftBtn.id = scrollerContainer.id + "_left_scroll";
    leftBtn.innerHTML = `<svg-icon src="icon-arrow" class="rotate-180" style="--icon-size: 16px;"><template shadowrootmode="open"><!---->
      <svg class="block h-full w-full" aria-label="Icon for icon-arrow">
        <use crossorigin="anonymous" href="//is-clinical-production.myshopify.com/cdn/shop/t/47/assets/icons.svg?v=117055188062501076751758611687#icon-arrow"></use>
      </svg>
    </template></svg-icon>`;
    leftBtn.disabled = true;
    leftBtn.addEventListener("click", () => {
        scrollerContainer.scrollBy({ left: -332, behavior: "smooth" });
        rightBtn.disabled = false;
        setTimeout(() => {
            if (scrollerContainer.scrollLeft <= 0) leftBtn.disabled = true;
        }, 100);
    });
    buttonContainer.appendChild(leftBtn);

    sectionGrid.addEventListener("scroll", updateButtonState);
    // Append to the parent of the section grid
    sectionGrid.appendChild(buttonContainer);
}

function updateButtonState(e) {
    const container = e.target; // the div being scrolled
    // Get the left and right buttons inside this container
    const leftBtn = document.getElementById(container.id + "_left_scroll");
    const rightBtn = document.getElementById(container.id + "_right_scroll");

    if (!leftBtn || !rightBtn) return; // safety check
    // Check scroll positions
    if (container.scrollLeft <= 0) {
        leftBtn.disabled = true;
    } else {
        leftBtn.disabled = false;
    }

    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 1) {
        rightBtn.disabled = true;
    } else {
        rightBtn.disabled = false;
    }
}

function centerActiveTabWhenMobile() {
    if (window.innerWidth <= 768) {
        const container = document.getElementById("tangent_custom_tabs");
        const activeTab = container.querySelector(".tab-radio.active");

        if (activeTab) {
            const containerRect = container.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();

            const scrollLeft =
                activeTab.offsetLeft -
                (containerRect.width / 2) +
                (tabRect.width / 2);

            container.scrollTo({
                left: scrollLeft,
                behavior: "smooth"
            });
        }
    }
}

const getSelectedVariant = (product, selected_variant_map) => {
    const variantIds = selected_variant_map[product.id] || [];

    if (variantIds.length > 0) {
        const selectedId = variantIds[0];
        const foundEdge = product.variants.edges.find(
            edge => extractVariantId(edge.node.id) == selectedId
        );
        if (foundEdge) {
            return foundEdge.node;
        }
    }
    return product.variants.edges[0]?.node || null;
};

function extractVariantId(gid) {
    return gid.split("/").pop();
}

function getVariantImageUrl(product, variant) {
    return variant.images?.nodes?.[0]?.url
        ?? product.images?.nodes?.[0]?.url
        ?? 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function getVariantId(variant) {
    return extractVariantId(variant.id);
}

function getVariantProductUrl(product, variantId) {
    return `${tangent_client_domain_url}/products/${product.handle}?variant=${variantId}`;
}

function renderProductPrice(section, product, variant) {
    return `
    <p id="tangent-product-price-${section}-${product.id}" class="tangent_product_price_text price-wrap">
      ${Number(variant.price).toFixed(2)}${tangent_client_domain_currency}
    </p>
  `;
}

// Renders the "Add to Cart" button
function renderAddToCartButton(product, variant, section, variantId) {
    const isActive = isProductActive(product, variant);

    const defaultText = isActive ? "Ajouter au panier" : out_of_stock_text;
    const classList = isActive ? "" : "disable-btn-wrapper";
    const disabledAttr = isActive ? "" : "disabled='disabled' aria-disabled='true'";

    if (isActive) {
        updateSectionAllToCartLink(section, variantId);
    }

    return `
        <button variant="secondary"
            class="${section}-${product.id} tangent-product-add-btn-wrapper tangent_add_to_cart_button btn ${classList}" 
            id="${variantId}" 
            ${disabledAttr}
            aria-label="${defaultText}"
        >
            ${defaultText}
        </button>
    `;
}

// Renders the cart SVG icon
function renderCartIcon(product, section) {
    return `
        <svg-icon class="tangent-cart-icon text-subdued-cobalt" 
            src="icon-cart" 
            style="--icon-size: 16px;" 
            data-product-id="${product.id}" 
            data-section="${section}">
            <template shadowrootmode="open">
                <svg class="block h-full w-full" aria-label="Icon for icon-cart">
                    <use crossorigin="anonymous" href="//is-clinical-production.myshopify.com/cdn/shop/t/47/assets/icons.svg?v=117055188062501076751758611687#icon-cart"></use>
                </svg>
            </template>
        </svg-icon>
    `;
}

function renderTags(tagsList) {
    const container = document.getElementById("skin-type-taging");
    if (!container) return;

    // const tagValues = {
    //     normal: "Normal",
    //     dry: "Dry",
    //     oily: "Oily",
    //     combination: "Combination",
    //     sensitive: "Sensitive",
    //     acne: "Blemish",
    //     "aging prevention": "Fine Lines",
    //     "aging correction": "Deep Wrinkles",
    //     "eye area": "Dark Circles",
    //     rosacea: "Rosacea",
    //     brightening: "Discoloration",
    //     dryness: "Dryness",
    //     irritated: "Irritation",
    //     reactive: "Reactive"
    // };

    const tagValues = {
        normal: "Normale",
        dry: "Sèche",
        oily: "Huileuse",
        combination: "Combinaison",

        primary_anti_aging: "Rides profondes",
        primary_blemish_prone: "Défaut",
        primary_discoloration_dark_spots: "Décoloration",
        primary_dark_circles: "Cernes",
        primary_dry_dehydrated_skin: "Sécheresse",
        primary_finelines_wrinkles_firmness: "Ridules",
        primary_oily_combination_skin: "Huileuse",
        primary_sensitive_skin_redness: "Sensible",
        primary_pollution_protection: "Protection contre la pollution",
        primary_minimize_pores: "Réduire les pores",
        primary_dull_skin: "Peau terne"
    };
    let html = "";

    const skinType = ["normal", "dry", "oily", "combination", "sensitive"];

    tagsList.forEach(tag => {
        if (tagValues[tag]) {
            if (skinType.includes(tag)) {
                html += `<h5><i>Type de peau</i> : <b>${tagValues[tag]}</b></h5>`;
            }
            else {
                html += `<h5><i>Préoccupation</i> : <b>${tagValues[tag]}</b></h5>`;
            }
        }
    });

    container.innerHTML = html;
}


// Combines button + icon into the full Add to Cart section
function renderAddToCartSection(product, variant, section, variantId) {
    return `
        <div class="tangent-addtocart-drawer btn btn-primary btn-sm" id="tangent-product-add-btn-${section}-${product.id}">
            ${renderProductVariants(product, variant, section, variantId)}
            ${renderAddToCartButton(product, variant, section, variantId)}
        </div>
        `;
        //${renderCartIcon(product, section)}
    
}

function renderVariantRadio(optionValue, product, sectionName, optionName, variantId, optionMatched) {
    // Check if this option matches the current variant OR if it's the first option
    const checkedAttr = optionMatched ? "checked" : "";
    if (optionName == "Tint") {
        if (optionValue.swatch == null || optionValue.swatch.color == null) {
            optionValue.swatch = { color: "#FFFFFF" };
        }
        return `
            <label style="background-color: ${optionValue.swatch.color};" class="tangent-variant-btn tangent-variant-swatch-btn">
                <input
                    type="radio"
                    name="variant-${product.id}-${sectionName}-${optionName}"
                    value="${optionValue}"
                    data-product-id="${product.id}"
                    data-variant-id="${variantId}"
                    data-option-name="${optionName}"
                    data-section="${sectionName}"
                    ${checkedAttr}
                />
            </label>
        `;
    }
    else {
        return `
            <label class="tangent-variant-btn">
                <input 
                    type="radio" 
                    name="variant-${product.id}-${sectionName}-${optionName}" 
                    value="${optionValue}" 
                    data-product-id="${product.id}" 
                    data-variant-id="${variantId}"
                    data-option-name="${optionName}"
                    data-section="${sectionName}" 
                    ${checkedAttr}
                />
                <span>${optionValue.name}</span>
            </label>
        `;
    }
}

// Main: render variants as radio group
function renderProductVariants(product, currentVariant, section) {
    if (!product.options || product.options.length < 1) {
        return "";
    }
    let optionsHtml = "";

    product.options.forEach(option => {
        let rowContainer = `<p id="selected-${product.id}-${section}-${option.name}" class="selected-variant-title">${option.name} : ${option.optionValues[0].name}</p>
            <div class='tangent-variant-row'>
        `;

        // Loop over optionValues array
        option.optionValues.forEach(optionValue => {
            let variant_id = extractVariantId(product.variants.edges.find(edge =>
                edge.node.selectedOptions.some(selectedOption =>
                    selectedOption.name === option.name && selectedOption.value === optionValue.name
                )
            )?.node.id);

            // variant_id = extractVariantId(currentVariant.id);
            rowContainer += renderVariantRadio(
                optionValue,
                product,
                section,
                option.name,            // option name
                variant_id,
                currentVariant.title.includes(optionValue.name)
            );
        });

        rowContainer += "</div>";
        optionsHtml += rowContainer;
    });


    return `
        <div class="tangent-variant-selector" role="radiogroup" aria-label="Select variant for ${product.title}">
            ${optionsHtml}
        </div>
    `;
}

// function renderRatingStars(product) {
//     if (!product.product_rating) return '';

//     // Parse the rating metafield
//     let rating = 0;
//     try {
//         const ratingData = JSON.parse(product.product_rating.value);
//         rating = parseFloat(ratingData.value);
//     } catch (e) {
//         console.error('Invalid rating metafield:', e);
//         return '';
//     }

//     const fullStar = '<span class="jdgm-star jdgm--on"></span>';
//     const halfStar = '<span class="jdgm-star jdgm--half"></span>';
//     const emptyStar = '<span class="jdgm-star jdgm--off"></span>';

//     // Round to nearest half
//     const rounded = Math.round(rating * 2) / 2;
//     const fullCount = Math.floor(rounded);
//     const hasHalf = rounded % 1 === 0.5;
//     const emptyCount = 5 - fullCount - (hasHalf ? 1 : 0);

//     let html = ``;
//     html += `<span class="jdgm-prev-badge__stars" data-score="${rating}" aria-label="${rating} stars">`;

//     for (let i = 0; i < fullCount; i++) html += fullStar;
//     if (hasHalf) html += halfStar;
//     for (let i = 0; i < emptyCount; i++) html += emptyStar;

//     html += `</span>`;

//     return html;
// }

// function renderReviewCount(product) {
//     if (!product.product_reviews) return '';
//     let count = 0;
//     try {
//         count = parseInt(product.product_reviews.value, 10);
//     } catch (e) {
//         console.error('Invalid review count metafield:', e);
//         return '';
//     }
//     return `&nbsp;${count} review${count !== 1 ? 's' : ''}`;
// }

// function renderRatingHTML(product) {
//     // Render stars and review count separately
//     const starsHTML = renderRatingStars(product);
//     const reviewsHTML = renderReviewCount(product);

//     return `<div id="custom-rating-section">${starsHTML} ${reviewsHTML}</div>`;
// }

function getProductHTML(product, variant, section) {
    const variantId = getVariantId(variant);
    const variantImageUrl = getVariantImageUrl(product, variant);
    const variantProductUrl = getVariantProductUrl(product, variantId);

    return `
    <div class="tangent-product-border-div">
        <div class="tangent-product-inner-div">
            <div class="tangent-product-image-container">
                <div id="tangent-product-image-container-${section}-${product.id}" class="tangent-product-image-container tangent-image-container">
                    <img id="tangent-product-image-${section}-${product.id}" src="${variantImageUrl}" class="tangent_product_image" alt="${product.title}">
                </div>
                ${renderAwardImages(product)}
            </div>
            
            <a class="tangent-text-link" target="_blank" href="${variantProductUrl}">
                ${renderProductCategory(product)}
                <p class="tangent-product-title tangent_product_title_text card-title h5 text-uppercase">${product.title}</p>
                ${renderSubtitleText(product)}
            </a>
            ${renderProductPrice(section, product, variant)}
                ${renderAddToCartSection(product, variant, section, variantId)}
        </div>
    </div>
  `;
}

const renderAwardImages = (product) => {
    const imageUrls = product.badges?.references?.edges
        ?.map(edge => edge?.node?.badgeImage?.reference?.image?.url)
        .filter(url => url !== undefined);

    if (imageUrls && imageUrls.length > 0) {
        return `
        <div class="tangent-award-image-container">
            ${imageUrls.map(url => `<img src="${url}" class="tangent-award-image" alt="Award Badge">`).join('')}
        </div>
        `;
    }
    return '';
}

const renderProductCategory = (product) => {
    return product.pdt_category?.value
        ? `<p class="tangent-product-category-title tangent_product_category_text text-grey-400">${product.pdt_category.value}</p>`
        : '';
}

const renderSubtitleText = (product) => {
    return product.subtitle?.value
        ? `<p class="tangent-product-subtitle tangent_product_subtitle_text text-grey-400">${product.subtitle.value}</p>`
        : '';
}

const isProductActive = (product, variant) => {
    return product?.status?.toLowerCase() === "active" && variant?.availableForSale;
};

// Show the wrapper
const showTabWrapper = () => {
    setElementDisplay("tab-wrapper", "block");
};

// Decide which index should be active based on tags
const getActiveTabIndex = (tags, radiosLength) => {
    if (tags.includes("routine_5mins")) return 0;
    if (tags.includes("routine_10mins")) return 1;
    if (radiosLength > 2) return 2; // third tab if available
    return 0; // fallback
};

// Activate tab by index
const activateTabByIndex = (index, radios) => {
    if (!radios[index]) return;

    radios[index].checked = true;
    switchTab(radios[index]);
};

// Main function
const setTabOpen = (tags = []) => {
    showTabWrapper();

    const radios = document.querySelectorAll('#tangent_custom_tabs input[type="radio"]');
    const activeIndex = getActiveTabIndex(tags, radios.length);

    activateTabByIndex(activeIndex, radios);
};


// Updating add all to cart object for sections
function updateSectionAllToCartLink(section, variant_id) {
    // Initialize the section map if it doesn't exist
    if (!sections_add_to_cart_map[section]) {
        sections_add_to_cart_map[section] = {
            count: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };
    }

    // Retrieve the section map entry
    let section_map = sections_add_to_cart_map[section];

    // Add the variant if it's not already in the list
    if (!section_map.list.includes(variant_id)) {
        section_map.list.push(variant_id);
        section_map.count++;
        section_map.cart_link += `&id[]=${variant_id}`;

        // Show the "Add All to Cart" button if there's more than 1 product
        if (section_map.count > 1) {
            let addAllButton = document.getElementById(`${section}`);
            let addAllButtonText = document.getElementById(`${section}_custom_text`);

            if (addAllButton) {
                addAllButton.style.display = "block";
            }
            if (addAllButtonText) {
                addAllButtonText.style.display = "block";
            }
        }
    }

}

const setElementDisplay = (element_id, displayType) => {
    const element = document.getElementById(element_id);
    if (!element) return;

    element.style.display = displayType;
}

function createFormDataFromIds(idArray) {
    return {
        items: idArray.map(id => {
            const item = { id, quantity: 1 };
            return item;
        })
    };
}


function addToCart(element) {
    const formData = createFormDataFromIds([element.id]);
    addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
    const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
    if (formData) {
        addToCartApi(formData, element);
    }
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}


function addToCartApi(payload, element, event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }

    element.innerHTML = `<div>Ajout au panier...</div>`;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(() => {
        element.innerHTML = default_addedToCartText;
        element.classList.add("added-to-cart-style");

        openCartDrawerWithoutRefresh();
    })
    .catch((error) => {
        console.error('Error:', error);
    });

    return false;
}

function openCartDrawerWithoutRefresh() {

    // Dawn / Shopify themes
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && cartDrawer.open) {
        cartDrawer.open();
        return;
    }

    // Alternative drawer trigger
    const drawerTrigger = document.querySelector('[href="/cart"], .cart-drawer-button');

    if (drawerTrigger) {
        drawerTrigger.click();
    }
}

function createSectionContainer(section_name) {
    const section_container = document.createElement("div");
    section_container.id = `${section_name}_container`;

    if (!excludedSections.includes(section_name)) {
        section_container.classList.add("tabcontent");
    }

    return section_container;
}

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add(
        "section_add_all_to_cart",
        `${section_name}_add_all_to_cart`,
        "btn"
    );
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;

    // Attach click listener
    add_all_to_cart_button.addEventListener("click", () => {
        addAllTocartFunction(add_all_to_cart_button);
    });

    return add_all_to_cart_button;
}

// Container for individual products (simplified)
const addSectionProductGridContainer = (sectionName) => {
    const div = document.createElement("div");
    div.id = `${sectionName}_product_grid`;
    div.classList.add("section_product_grid", `${sectionName}_product_grid`);
    return div;
};

// Tab Button Creation
function createTabButton(section_name) {
    const tab_label = document.createElement("label");
    tab_label.classList.add("tab-radio");

    const radio_input = document.createElement("input");
    radio_input.type = "radio";
    radio_input.name = "tab_option";
    radio_input.value = section_name;
    radio_input.id = `tab_${section_name}`;
    radio_input.checked = false;
    radio_input.addEventListener("change", () => switchTab(radio_input));

    const tab_span = document.createElement("span");
    tab_span.textContent = getTabTitle(section_name);

    tab_label.setAttribute("for", radio_input.id);
    tab_label.appendChild(radio_input);
    tab_label.appendChild(tab_span);

    tangent_custom_tabs.appendChild(tab_label);
}

function getTabTitle(section) {
    // If mapping exists and has this key, return it
    if (tabs_title_mapping && tabs_title_mapping.hasOwnProperty(section)) {
        return tabs_title_mapping[section];
    }

    // Otherwise, auto-generate a readable title
    return section
        .replace(/^section_/, "") // remove "section_" prefix
        .replace(/_/g, " ")       // replace all underscores with spaces
        .replace(/\b\w/g, c => c.toUpperCase()); // capitalize first letter of each word
}

// Product Section Creation
function createProductSection(product_sections, text_sections) {
    for (const section_name in product_sections) {
        
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);

        // Creating text sections before products sections if exists
        if (text_sections != undefined) {
            createTextSectionBeforeProducts(text_sections, section_container, section_name);
        }

        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));

        const addTocartContainer = createContainer(section_name);
        // Creating add all to cart button for the section    
        addTocartContainer.appendChild(createSectionAddAllToCart(section_name));
        // addTocartContainer.appendChild(createCustomText(section_name));

        section_container.appendChild(addTocartContainer);
        // Add to main container wrapper
        tangent_sections_wrapper_element.appendChild(section_container);

        if (!excludeProductSections.includes(section_name)) {
            createTabButton(section_name);
        }

        
    }
}

function createContainer(section) {
    const div = document.createElement("div");
    div.id = `${section}_custom_container`;
    return div;
}

// Custom Text Creation (simplified)
const createCustomText = (sectionName) => {
    const div = document.createElement("div");
    div.id = `${sectionName}_custom_text`;
    div.classList.add("section_custom_text", "section_add_all_to_cart_custom_text", `${sectionName}_custom_text`);
    div.innerHTML = `<p class="add-to-cart-button-text">
        Get entire regiment and save $20.00
    </p>`;
    return div;
};

// Text Sections with products sections (simplified)
const createTextSectionBeforeProducts = (textSections, sectionContainer, sectionName) => {
    console.log("textSections", textSections);
    console.log(sectionName);
    if (!textSections[sectionName]) return;

    const div = document.createElement("div");
    div.id = `${sectionName}_text_container`;
    div.classList.add("section_text_container", `${sectionName}_text_container`);
    div.innerHTML = textSections[sectionName].join(" ");

    sectionContainer.appendChild(div);
};

// Section Text Creation (no product section)
const createTextSection = (productSections, textSections) => {
    Object.keys(textSections).forEach((sectionName) => {
        // Skip if already exists in product sections
        if (productSections[sectionName] || (!productSections[sectionName] && sectionName == "section_additional_products")) return;
        const container = createSectionContainer(sectionName);

        const div = document.createElement("div");
        div.id = `${sectionName}_text_container`;
        div.classList.add("section_text_container", `${sectionName}_text_container`);
        div.innerHTML = textSections[sectionName].join(" ");
        container.appendChild(div);

        // Insert into the right parent
        if (sectionName === "section_selfie") {
            document
                .querySelector("#section_selfie_container_parent")
                ?.appendChild(container);
        } 
        else if (sectionName === "section_education_content") {
            document
                .querySelector("#tangent_education_container")
                ?.appendChild(container);
        }
        else {
            tangent_sections_wrapper_element.appendChild(container);
        }
    });
};

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("tangent_selfie_image");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("loading-section", "none");
        setElementDisplay("canvas_img", "block");
        setElementDisplay("tangent_selfie_image", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
        document.getElementById("section_selfie_container_parent").style.borderBottom = "none";
    } else {
        setElementDisplay("tangent_selfie_container", "none");
    }
}

// Show/Hide tab content for radio-style tabs
function switchTab(element) {
    // Hide all tab content
    document.querySelectorAll(".tabcontent").forEach(tab => tab.style.display = "none");

    // Show selected tab content
    const sectionId = element.value + "_container";
    setElementDisplay(sectionId, "flex");

    // Remove 'active' from all labels
    document.querySelectorAll("#tangent_custom_tabs label").forEach(label => {
        label.classList.remove("active");
    });

    // Add 'active' class to parent label
    element.parentElement.classList.add("active");
}

// Load elements having load-on-data class
function loadElementsOnResponseData() {
    document.querySelectorAll('.load-on-data').forEach(el => {
        el.style.display = "block";
    });
}


// Selfie Mapping data api call
async function getSelfieMapping(selfie_id) {
    const selfie_api_url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`;

    try {
        const res = await fetch(selfie_api_url);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;
        if (tangent_facemap_data) {
            // Update scores
            setScores(tangent_facemap_data.scores);

            // Update selfie image
            const canvasImg = document.getElementById("canvas_img");
            if (canvasImg) canvasImg.src = tangent_facemap_data.url;
        }

        // Hide loading, show image
        setElementDisplay("loading-section", "none");
        setElementDisplay("canvas_img", "block");

    } catch (err) {
        console.error("Error fetching selfie:", err);
        setElementDisplay("loading-section", "none");
    }
}


// Setting scores below the selfie
function setScores(scores) {
    let scores_present = false;

    const scoreMap = {
        acne: "Acne",
        rosacea: "Rosacea",
        darkspots: "DarkSpots",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    Object.keys(scores).forEach(key => {
        if (scoreMap[key]) {
            const containerId = `${scoreMap[key]}_Score_container`;
            const scoreId = `#${scoreMap[key]}_Score`;
            setElementDisplay(containerId, "flex");
            document.querySelector(scoreId).innerHTML = scores[key] + "%";
            scores_present = true;
        }
    });

    if (scores_present) {
        setElementDisplay("facemap_all_scores_container", "flex");
    }
}

// Function to enable all button and icon listeners
function enableButtonListener() {
    // Add to cart buttons
    document.querySelectorAll('.tangent-product-add-btn-wrapper')
        .forEach(btn => btn.addEventListener('click', () => addToCart(btn)));

    // SVG icons
    document.querySelectorAll('.tangent-cart-icon')
        .forEach(svgIcon => attachSvgIconListener(svgIcon));

    // Variant radio buttons
    document.querySelectorAll('.tangent-variant-selector input[type="radio"]')
        .forEach(radio => radio.addEventListener('change', () => changeCurrentVariant(radio)));


    // Image container click to close drawer
    document.querySelectorAll('.tangent-image-container')
        .forEach(imgLink => imgLink.addEventListener('click', () => resetDrawerStates()));
}

function changeCurrentVariant(radio) {
    const productId = radio.getAttribute('data-product-id');
    const variantId = radio.getAttribute('data-variant-id');
    const optionName = radio.getAttribute('data-option-name');
    const section = radio.getAttribute('data-section');

    updateSelectedProduct(productId, variantId);
    resetAddToCartButton(section, productId, variantId);

    const { product, variant } = getProductAndVariant(productId, variantId);
    if (!product || !variant) return;

    updateSectionAllToCartLink(section, variantId);
    updateProductImage(section, productId, product, variant);
    updateProductPrice(section, productId, variant);
    updateVariantTitle(productId, section, variant, optionName);
}

function updateVariantTitle(productId, section, variant, optionName) {
    const titleElement = document.getElementById(`selected-${productId}-${section}-${optionName}`);
    if (!titleElement) return;
    variant.selectedOptions.forEach(opt => {
        if (opt.name == optionName) {
            titleElement.innerHTML = `${optionName} : ${opt.value}`;
        }
    });
}

function updateSelectedProduct(productId, variantId) {
    tangent_selected_product_map[productId] = variantId;
}

function resetAddToCartButton(section, productId, variantId) {
    const addToCartButton = document.querySelector(`.${section}-${productId}`);
    if (!addToCartButton) return;

    addToCartButton.id = variantId;
    addToCartButton.innerHTML = default_addToCartText;
    addToCartButton.classList.remove("added-to-cart-style", "disable-btn-wrapper");
    addToCartButton.disabled = false;
    addToCartButton.setAttribute("aria-disabled", "false");
}

function getProductAndVariant(productId, variantId) {
    const product = Object.values(tangent_recommended_products)
        .find(product => product.id == productId);

    const variant = product?.variants.edges.find(
        edge => getVariantId(edge.node) == variantId
    )?.node;

    return { product, variant };
}

function updateProductImage(section, productId, product, variant) {
    const imageElement = document.getElementById(`tangent-product-image-${section}-${productId}`);
    if (!imageElement) return;
    imageElement.src = getVariantImageUrl(product, variant);
}

function updateProductPrice(section, productId, variant) {
    const priceElement = document.getElementById(`tangent-product-price-${section}-${productId}`);
    if (!priceElement) return;
    priceElement.innerHTML = `${tangent_client_domain_currency}${Number(variant.price).toFixed(2)}`;
}

// Function to attach click listener to a single SVG icon
function attachSvgIconListener(svgIcon) {
    svgIcon.addEventListener('click', (e) => {
        const productId = svgIcon.getAttribute('data-product-id');
        const section = svgIcon.getAttribute('data-section');

        // Get the drawer for this product
        const drawerId = `tangent-product-add-btn-${section}-${productId}`;
        const drawer = document.getElementById(drawerId);

        if (!drawer) return;

        resetDrawerStates();

        const imageContainerId = `tangent-product-image-container-${section}-${productId}`;
        document.querySelectorAll('.tangent-product-image-container').forEach(imgLink => {
            if (imgLink.id == imageContainerId) {
                imgLink.classList.add('blur-background');
            }
        });

        // Toggle this drawer
        drawer.classList.toggle('active');
    });
}

function resetDrawerStates() {
    document.querySelectorAll('.tangent-addtocart-drawer').forEach(d => {
        d.classList.remove('active');
    });
    document.querySelectorAll('.tangent-product-image-container').forEach(imgLink => {
        imgLink.classList.remove('blur-background');
    });
}

function enableSelfieDependedStaticElements() {
    setElementDisplay("tangent_score_description", "block");
    setElementDisplay("skin-health-title-container", "block");
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas() {
    if (getSelfieId() != null) {

        var selfie_canvas = document.querySelector('#selfie_canvas');
        var selfie_canvas_ctx = selfie_canvas.getContext('2d');

        selfie_canvas.addEventListener('click', function (e) {
            getCursorPosition(selfie_canvas, e)
        });

        var canvas_img = document.querySelector('#canvas_img');
        setCanvasDimensions(selfie_canvas, canvas_img);

        var prop = getImageSize(canvas_img.naturalWidth);

        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"], getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
    selfie_canvas.width = canvas_img.naturalWidth;
    selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
    var prop = imgWidth / 400;
    return prop;
}

const getDarkCircleBlur = (prop) => {
    if (prop < 1) {
        return 'blur(1px)';
    }
    else if (prop < 1.5) {
        return 'blur(2px)';
    }
    else if (prop < 2) {
        return 'blur(4px)';
    }
    else if (prop < 3) {
        return 'blur(7px)';
    }
    else if (prop < 4) {
        return 'blur(12px)';
    }
    else {

    }
}

const getRosaceaBlur = (prop) => {
    if (prop < 1) {
        return 'blur(4px)';
    }
    else if (prop < 1.5) {
        return 'blur(4px)';
    }
    else if (prop < 2) {
        return 'blur(5px)';
    }
    else if (prop < 3) {
        return 'blur(13px)';
    }
    else if (prop < 4) {
        return 'blur(18px)';
    }
    else {
        console.log("out of bound props - Rosacea");
    }
}

const getAcneLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 7;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - Acne");
    }
}

const getDarkSpotsLineWidth = (prop) => {
    if (prop < 1) {
        return 1;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 6;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - DarkSpots");
    }
}

const getTextureLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 3;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 16;
    }
    else {
        return 20;
    }
}

const getWrinkleLineWidth = (prop) => {
    if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 15;
    }
    else if (prop < 4) {
        return 30;
    }
    else {
        console.log("out of bound props - Wrinkle");
    }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(28, 30, 82, 0.3)';
    drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
    context.fillStyle = 'rgba(24, 96, 3, 0.5)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";
    drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(206, 66, 66, 0.5)';
    drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
    context.lineWidth = lineWidth;
    context.filter = 'none';
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";
    drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
    context.fillStyle = 'rgba(81, 212, 191, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";
    drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
    context.fillStyle = 'rgba(234, 220, 96, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";
    drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
    for (let i = 0; i < contours.length; i++) {
        drawContour(context, contours[i], fill, stroke)
    }
}

const drawContour = (context, contour_coordinates, fill = false, stroke = false) => {
    context.beginPath();
    for (let i = 0; i < contour_coordinates.length; i++) {
        let point = contour_coordinates[i]
        if (i == 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }
    context.closePath();
    if (fill) context.fill();
    if (stroke) context.stroke();
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

    const ctx = canvas.getContext('2d');
    const bb = canvas.getBoundingClientRect();
    var point = {
        _x: Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
        _y: Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
    }

    var skin_conditions = ["acne", "darkspots", "wrinkles", "dark_circles", "rosacea"];
    var click_found = false;
    for (var sc = 0; sc < skin_conditions.length; sc++) {
        if (isPointInsidePoligon(point, tangent_facemap_data[skin_conditions[sc]])) {
            // openConditionMessage(canvas, skin_conditions[sc]);
            click_found = true;
            break;
        }
    }
    if (!click_found) {
        tangent_condition_message_popoup.style.display = "none";
        console.log("no condition click");
    }
}

function openConditionMessage(canvas, condition) {
    tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
    let rect = canvas.getBoundingClientRect();
    var point = {
        _x: event.clientX - rect.left,
        _y: event.clientY - rect.top
    }

    // Positioning Popup
    Object.assign(
        tangent_condition_message_popoup.style,
        {
            display: "block",
            left: (point._x) + "px",
            top: (point._y) + "px"
        }
    );
}


// Check whether click is inside condition points
function isPointInsidePoligon(pt, points_list) {
    // https://stackoverflow.com/a/29915728/960654
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    var x = pt._x,
        y = pt._y

    var inside = false;
    for (var c = 0; c < points_list.length; c++) {
        var points = points_list[c];
        for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i][0],
                yi = points[i][1]
            var xj = points[j][0],
                yj = points[j][1]

            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
            if (intersect) inside = !inside
        }
    }
    return inside
}